import styled from 'styled-components';
import { CommonDiv } from 'styles/common';

const InputRadio = styled.input`
  position: absolute;
  left: -9999px;
  :not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  :checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  :checked + label:before {
    border: 2px solid ${props => props.theme.color.primary};
  }
`;

const LabelRadio = styled(CommonDiv.withComponent('label'))`
  position: relative;
  padding-left: 38px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  :before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    border: 2px solid
      ${props =>
    props.error ? props.theme.color.error : props.theme.color.border};
    background: #fff;
  }
  :after {
    content: '';
    width: 14px;
    height: 14px;
    background: ${props => props.theme.color.primary};
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
`;

export { InputRadio, LabelRadio };
